import * as actions from '../actions/actionTypes';
import initialState from './initialState';

/**
 * Handles analytics report periods dropdown state.
 * @param {Array} [state] The analytics report periods currently in the store, or the initial state
 * @param {Object} action The action to be handled
 * @returns {Array} The analytics report periods
 */
export default function analyticsReportPeriodsDropdown(
  state = initialState.analyticsReportPeriods,
  action
) {
  switch (action.type) {
    case actions.LOAD_ANALYTICS_REPORT_PERIODS_SUCCESS:
      return action.analyticsReportPeriods;
    case actions.UNLOAD_CLIENT:
      return initialState.analyticsReportPeriods;
    case actions.LOAD_ANALYTICS_REPORT_PERIODS_FAILURE:
      return initialState.analyticsReportPeriods;
    default:
      return state;
  }
}
